import React from 'react';
import { DeliveryStatus } from '../../api/models/deliveries';
import { Tag } from 'antd';
import i18next from '../../i18next';
import { PresetColorType, PresetStatusColorType } from 'antd/lib/_util/colors';
import { isNumber } from '../../utils/componentHelpers';

type StatusTagProps = {
  status: DeliveryStatus;
  eta?: number;
};

const StatusTag = ({ status, eta }: StatusTagProps) => {
  let tagStyle: PresetColorType | PresetStatusColorType;
  let isEtaDisplayed = false;
  switch (status) {
    case DeliveryStatus.Assigned:
    case DeliveryStatus.InProgress:
      isEtaDisplayed = isNumber(eta);
      tagStyle = 'success';
      break;
    case DeliveryStatus.Delivered:
      tagStyle = 'success';
      break;
    case DeliveryStatus.AtPickup:
      tagStyle = 'warning';
      break;
    case DeliveryStatus.Cancelled:
    case DeliveryStatus.CNF:
      tagStyle = 'error';
      break;
    case DeliveryStatus.Pending:
    default:
      tagStyle = 'default';
      break;
  }
  return (
    <Tag color={tagStyle}>
      {i18next.t(`deliveries.deliveryStatus.${status}${isEtaDisplayed ? 'Eta' : ''}`, { eta })}
    </Tag>
  );
};

export default StatusTag;
